import React, { useContext, useEffect } from 'react'
import Helmet from 'react-helmet'
import './ContactUs.scss'
import { Row, Col, Button } from 'reactstrap'
import { ContentfulContext } from '../../shared/ContentfulContext'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const { PUBLIC_URL } = process.env

// const ContactUs = ({data}) => {
// 	const {contactEmail, contactNumber, contactTitle, faxNumber, faxTitle, header, hoursText, hoursTitle, text1, text2, title1, title2} = data

//     return (
//         <div className="contact-page container">
//             <Row className="align-items-center contact-page-header">
//                 <Col sm="2" md="1"><span className="d-none d-md-block mdi mdi-phone-classic" /></Col>
//                 <Col sm="11">
//                     <h3 className="contact-page-header-text">
//                         <span className="d-none d-sm-inline">
//                             {header}
//                     </span>
//                 </h3>
//                 </Col>
//             </Row>
//             <br />
//             <h3 className="contact-page-headline"><strong>{title1}</strong></h3>
//             <ul>
//                 {/* <li className="contact-page-secondary">All e-mails and faxes will be answered within 1 business day&nbsp;</li> */}
//                 <li className="contact-page-secondary">{documentToReactComponents(text1)}</li>
//             </ul>
//             {/* <br /> */}
//             {/* <h3 className="contact-page-headline"><strong>{title2}</strong></h3>
//             <h4 className="contact-page-secondary">
//                 {documentToReactComponents(text2)}
//         </h4> */}
//             <br />
//             <h3 className="contact-page-headline"><strong>{hoursTitle}</strong></h3>
//             <h4 className="contact-page-secondary contact-page_hours">{hoursText}</h4>
//             <br />
//             <h3 className="contact-page-headline"><strong>{contactTitle}</strong></h3>
//             <h4 className="contact-page-secondary"><a className="contact-page-tel" href={`tel:1-${contactNumber}`}>{contactNumber}</a></h4>
//             <h4 className="contact-page-secondary"><a href={`mailto:${contactEmail}`}>{contactEmail}</a></h4>
//             <br />
//             <h3 className="contact-page-headline"><strong>{faxTitle}</strong></h3>
//             <h4 className="contact-page-secondary">{faxNumber}</h4>
//             <br />
//             <br />
//             {process.env.LIVE_CHAT_URL
//                 && <a href={process.env.LIVE_CHAT_URL} target="_blank" rel="noopener noreferrer">
//                     <Button color="primary">
//                         Live Chat <i className="mdi mdi-face-agent" />
//                     </Button>
//                 </a>
//             }
//             {/* <br />
//             <br />
//             <a href="/beta/issue" target="_blank" rel="noopener noreferrer">
//                 <Button color="primary">
//                     Report Issue
//             </Button>
//             </a> */}
//         </div>
//     )
// }

// export default ContactUs

/*emerald work*/

const ContactUsHero = () => {
  return (
    <div className="contact-us-hero cuh">
      <div className="cuh__image"></div>
      <div className="container">
        <div className="cuh__wrapper">
          <div className="cuh__block">
            <h1 className="cuh__title white">
              Available. <br />
              Always.
            </h1>

            <p className="cuh__desc white">
              Our agility, knowledge, and global reach keep your business a step ahead of whatever
              comes next.
            </p>

            <a
              href={`${PUBLIC_URL}/products/1`}
              className="home-btn home-btn--grey home-btn--small"
            >
              Shop Now
            </a>
          </div>

          <div className="cuh__block bgd">
            <img
              className="cuh__clock"
              src={`${PUBLIC_URL}/images/contact-us-clock.png`}
              alt="line icon clock"
              loading="lazy"
            />
            <div className="cuh__time">
              <p className="cuh__text red">Sales Support Team 9am - 5pm EST</p>
              <p className="cuh__text">Additional Support Available 24/7</p>
            </div>
            <div className="cuh__info">
              <p className="cuh__text">Call: 800.569.0570</p>
              <p className="cuh__text">support@dealmed.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const CustomerServices = () => {
  return (
    <div className="customer-services cstms">
      <div className="container">
        <h2 className="cstms__title">Customer Service is Our Cornerstone</h2>

        <div className="cstms__wrapper">
          <div className="cstms__box">
            <div className="cstms__box-icon">
              <img src={`${PUBLIC_URL}/images/24.png`} alt="" loading="lazy" />
            </div>

            <div className="cstms__box-desc">
              <p>Personalized customer service that suits you.</p>
            </div>
          </div>
          <div className="cstms__box">
            <div className="cstms__box-icon">
              <img src={`${PUBLIC_URL}/images/message-icon.png`} alt="" loading="lazy" />
            </div>

            <div className="cstms__box-desc">
              <p> Available 24 hours a day, every day of the year.</p>
            </div>
          </div>
          <div className="cstms__box">
            <div className="cstms__box-icon">
              <img
                src={`${PUBLIC_URL}/images/red-cart.png`}
                alt="red line icon cart"
                loading="lazy"
              />
            </div>

            <div className="cstms__box-desc">
              <p> Website ordering and account access available 24/7</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const TotalServices = () => {
  return (
    <div className="customer-services total-services ttls">
      <div className="container">
        <h2 className="ttls__title">A Total Suite of Services</h2>

        <div className="ttls__wrapper">
          <div className="ttls__texts">
            <p className="ttls__text">
              At Dealmed, we’re more than just a medical supplies company – we’re a people-first
              company. Our team is here to help you out no matter what, and we’re committed to going
              above and beyond to ensure you have the best possible experience with us.
            </p>
            <p className="ttls__text">
              Whether you’re a doctor, a hospital, or a B2B partner, we understand that your needs
              are unique. That’s why we take a personalized approach to customer service. We’ll work
              with you to understand your specific requirements and find the right solutions to meet
              your needs.
            </p>
            <p className="ttls__text">
              Our team is made up of friendly, knowledgeable, and experienced professionals who are
              dedicated to providing exceptional service. We know that your time is valuable, which
              is why we always strive to respond to your queries as quickly as possible.
            </p>
            <p className="ttls__text">
              At Dealmed, we believe that great customer service is all about building
              relationships. That’s why we take the time to get to know our clients and understand
              their needs. Whether you need help with a product, have a question about an order, or
              just want to chat, we’re always here for you.
            </p>
            <p className="ttls__text">
              So if you’re looking for a medical supplies company that puts people first, you’ve
              come to the right place. Contact us today, and let our friendly team help you out in
              any way we can.
            </p>
          </div>

          <div className="ttls__warehouse">
            <div className="ttls__warehouse-image">
              <img
                src={`${PUBLIC_URL}/images/warehouse.jpg`}
                alt="Dealmed warehouse full of medical supplies"
                loading="lazy"
              />
            </div>
            <div className="ttls__warehouse-items">
              <ul className="ttls__warehouse-list">
                <li className="ttls__warehouse-list-item">
                  <p>Six Locations</p>
                </li>
                <li className="ttls__warehouse-list-item">
                  <p>Warehouses equipped with advanced order- picking technology</p>
                </li>
                <li className="ttls__warehouse-list-item">
                  <p>Licensed to Sell Pharmaceuticals in Fifteen States</p>
                </li>
                <li className="ttls__warehouse-list-item">
                  <p>In-House Pharmacists</p>
                </li>
                <li className="ttls__warehouse-list-item">
                  <p>Health Industry Distributor Association (HIDA) Participants</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ContactUs = () => {
  return (
    <>
      <ContactUsHero />
      <CustomerServices />
      <TotalServices />
    </>
  )
}

export default ContactUs
